/**
 * Les formats d'affichage du jeu, au meme endroit.
 *
 * Ce ne sont pas des details : « +400 » et « 400 » ne disent pas la meme
 * chose, et une cote ecrite « x3 » puis « x2.2 » se lit mal. Centraliser
 * evite que deux ecrans racontent la meme somme differemment.
 */

const MONEY = new Intl.NumberFormat('fr-FR');

/** Une somme. L'espace insecable evite « 1 » seul en fin de ligne. */
export function money(amount: number): string {
  return MONEY.format(Math.round(amount));
}

/** Une variation. Le signe est TOUJOURS present : c'est lui qui porte le sens. */
export function delta(amount: number): string {
  const rounded = Math.round(amount);
  if (rounded === 0) return '0';
  return `${rounded > 0 ? '+' : '-'}${MONEY.format(Math.abs(rounded))}`;
}

/** Une cote. Deux decimales toujours, pour que le chiffre ne saute pas. */
export function odds(value: number): string {
  return `x${value.toFixed(2)}`;
}

/** Un chrono de phase : on compte en secondes, jamais en minutes. */
export function clock(ms: number): string {
  return String(Math.max(0, Math.ceil(ms / 1000)));
}

/**
 * Le nom lisible d'un mini-jeu. Le serveur envoie un identifiant technique
 * (`lyrics`, `qcm`...) ; l'inconnu retombe sur l'identifiant brut plutot que
 * sur un vide — un mini-jeu ajoute reste ainsi affichable sans toucher ici.
 */
const MINIGAMES: Record<string, string> = {
  lyrics: 'Paroles',
  song: 'Extrait audio',
  artist: 'Quel artiste',
  cloze: 'Paroles a trou',
  quote: 'Replique',
  blur: 'Image pixelisee',
  emoji: 'Emojis',
  qcm: 'QCM',
  order: 'Remise en ordre',
  color: 'Couleur',
  year: 'Annee',
};

export function miniGameLabel(id: string): string {
  return MINIGAMES[id] ?? id;
}

const THEMES: Record<string, string> = {
  musique: 'Musique',
  histoire: 'Histoire',
  image: 'Image',
  couleur: 'Couleur',
  culture: 'Culture',
  cinema: 'Cinema',
};

export function themeLabel(id: string): string {
  return THEMES[id] ?? id;
}
